import { CardLink } from '@/components/common/Card'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type GalleryGroupType } from '@/defs/gallery'
import { cn } from '@/utils/commonUtil'

import styles from './CardCatalog.module.scss'

type Props = {
  groups: GalleryGroupType[]
  hideCount?: boolean
  variant?: 'embed'
}

export const CardCatalog = ({ groups, hideCount, variant }: Props) => {
  const groupCount = String(groups.length > 5 ? 6 : groups.length)

  return (
    <div className={cn(styles.container, { groupCount, styles, variant })}>
      <ul className={styles.catalog}>
        {groups.map((group) => (
          <li className={styles.group} key={group.label}>
            <h3 className={styles.groupTitle}>
              <IconWithLabel iconBefore={group.icon} iconBeforeSize='sm'>
                {group.label}
              </IconWithLabel>
              <span className={styles.groupTitleCount}>
                ({group.recs.reduce((acc, rec) => acc + (rec.count || 1), 0)})
              </span>
            </h3>
            <ul className={styles.groupCards}>
              {group.recs.map((rec, i) => (
                <li key={i}>
                  <CardLink className={styles.card} rec={rec}>
                    {!hideCount && <strong className={styles.count}>{rec.count || 1}</strong>}
                    <span>{rec.name}</span>
                  </CardLink>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  )
}
